/**
 * Главная кнопка экрана. Лежит в теле страницы последним элементом и висит
 * над нижней панелью, пока конец страницы не виден (см. .action в styles.css).
 * Системную MainButton Telegram не используем: она рисуется под нижней
 * панелью вкладок и выглядит чужой на странице.
 */
import type { ReactElement } from 'react';
import { t } from '../i18n';

export interface ActionButtonProps {
  text: string;
  /** Вторая строка мелким шрифтом, например условия. */
  caption?: string;
  onClick: () => void;
  enabled?: boolean;
  loading?: boolean;
  visible?: boolean;
  /** Выглядит активной, даже когда нажимать рано: причину объясняет onClick. */
  alwaysActive?: boolean;
}

export function ActionButton({
  text,
  caption,
  onClick,
  enabled = true,
  loading = false,
  visible = true,
  alwaysActive = false,
}: ActionButtonProps): ReactElement | null {
  if (!visible) return null;
  return (
    <div className="action">
      <button
        type="button"
        className="btn primary block"
        disabled={alwaysActive ? loading : !enabled || loading}
        onClick={onClick}
      >
        {loading ? t('components.action.wait') : text}
        {caption ? <span className="action-caption">{caption}</span> : null}
      </button>
    </div>
  );
}
